<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white"> Dashboard</router-link>
            <span class="text-white"><i class="fa fa-ellipsis-v px-2"></i>News Setup</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <div class="card">
                        <div class="card-body">
                            <modal :show.sync="modals.newModal" modal-classes="modal-dialog-centered modal-lg">
                                <div class="card bg-secondary border-0 mb-0">
                                    <div class="card-body">
                                        <PageSpinner :onloader="onloader" />
                                        <form role="form">
                                            <div class="row">


                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Is It Sportlight</label>
                                                        <select v-model="isSpotlightval" class="form-control">
                                                            <option value="false">No</option>
                                                            <option value="true">Yes</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Title</label>
                                                        <vue-editor id="newsTitleval" v-model="newsTitleval"
                                                            ref="newsTitleval">

                                                        </vue-editor>
                                                    </div>
                                                </div>

                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Short Details</label>
                                                        <vue-editor id="newsDetailsShortval"
                                                            v-model="newsDetailsShortval" ref="newsDetailsShortval">

                                                        </vue-editor>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="form-group">
                                                        <label>Full Details</label>
                                                        <vue-editor id="newsDetailsval" v-model="newsDetailsval"
                                                            ref="newsDetailsval">

                                                        </vue-editor>
                                                    </div>
                                                </div>
                                                <div class="col-md-12 pb-2">
                                                    <div class="row">
                                                        <div class="col">
                                                            <img v-if="newsImagePathval" :src="newsImagePathval"
                                                                class="img-fluid" />
                                                            <img v-else src="/img/brand/empty.png" class="img-fluid" />
                                                        </div>
                                                        <div class="col">
                                                            <ImageUploader
                                                                @emitOutImgPathval="UpdateNewsImagePathval" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <template slot="footer">

                                    <base-button type="default" @click="modals.newModal = false">Cancel
                                    </base-button>
                                    <base-button type="success" @click.prevent="submitdata()">Submit
                                    </base-button>
                                </template>
                            </modal>

                            <div>
                                <div class="form-inline">
                                    <select v-model="newsCategoryIdval" class="form-control"
                                        :disabled="newsCategoryItems === null">
                                        <option value="0">{{ newsCategoryItems === null ? '⏳ Loading...' : '-Select news         category - '
                                            }}</option>
                                        <option v-for="item in newsCategoryItems" :key="item.newsCategoryId"
                                            v-bind:value="item.newsCategoryId">
                                            {{ item.newsCategoryName }}
                                        </option>
                                    </select>
                                    <select v-model="schoolTypeIdval" class="form-control"
                                        @change="GetSchoolsForPortal(); onSchoolChanged();"
                                        :disabled="schoolTypeItems === null">
                                        <option value="0">{{ schoolTypeItems === null ? '⏳ Loading...' : '-School Type -                                            '
                                            }}</option>
                                        <option v-for="item in schoolTypeItems" :key="item.schoolTypeId"
                                            v-bind:value="item.schoolTypeId">
                                            {{ item.schoolTypeName }}
                                        </option>
                                    </select>
                                    <select v-if="newsCategoryIdval == 2" v-model="schoolIdval" class="form-control"
                                        @change="onSchoolChanged()" :disabled="schoolItems === null">
                                        <option value="0">{{ schoolItems === null ? '⏳ Loading...' : '- Select School -'
                                            }}</option>
                                        <option v-for="item in schoolItems" :key="item.schoolId"
                                            v-bind:value="item.schoolId">
                                            {{ item.schoolName }}
                                        </option>
                                    </select>
                                    <button class="btn btn-success" v-on:click="openNew()">
                                        <i class="fa fa-edit"></i> New
                                    </button>
                                </div>

                                <div class="justify-content-end form-inline">
                                    <base-input class="input-group-alternative" placeholder="Search here..."
                                        addon-left-icon="fa fa-search" v-model="searchValueval">
                                    </base-input>
                                </div>
                                <div v-if="newsItems">
                                    <div v-for="item in newsItems" :key="item.newsId">
                                        <div class="card mt-2">
                                            <div class="card-body bg-secondary">
                                                <div class="card">
                                                    <div class="row">
                                                        <div class="col-lg-3">
                                                            <img :src="item.newsImagePath
                                                                " class="card-img-top" alt="...">
                                                        </div>
                                                        <div class="col-lg-9">
                                                            <h5 class="card-title" v-html="item.newsTitle"></h5>
                                                            <div class="card-text" v-html="item.newsDetailsShort"></div>
                                                            <div class="card-footer text-center">
                                                                <button class="btn btn-secondary btn-sm"
                                                                    v-on:click="edititem(item)">
                                                                    <i class="fa fa-edit"></i> Edit
                                                                </button>
                                                                <button class="btn btn-danger btn-sm"
                                                                    v-on:click="edititem(item.newsId)">
                                                                    <i class="fa fa-times"></i> Delete
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <BasePagination :meta="paginationMeta" @page-changed="GetNewsForPortal" />
                            </div>

                        </div>
                    </div>
                </card>
            </div>

            <!-- End charts-->
        </div>
    </div>
</template>

<script>
import moment from "moment";
import 'quill/dist/quill.snow.css'
import { VueEditor } from 'vue2-quill-editor'
import PageSpinner from "@/components/PageSpinner";
import ValidateAccessToken from "@/mixins/ValidateAccessToken.mixins";
import Alert from "@/mixins/Alert.mixins"
import katex from 'katex';
import 'katex/dist/katex.min.css';
import ImageUploader from "@/components/ImageUploader"
import BasePagination from '@/components/BasePagination.vue';
window.katex = katex;
export default {
    name: "questionheader",
    mixins: [ValidateAccessToken, Alert],
    components: {
        PageSpinner,
        VueEditor,
        ImageUploader,
        BasePagination
    },
    data() {
        return {
            accessDetails: null,
            newsIdval: 0,
            newsCategoryIdval: 0,
            schoolTypeIdval: 0,
            schoolIdval: 0,
            newsTitleval: "",
            newsDetailsval: "",
            newsDetailsShortval: "",
            newsImagePathval: null,
            isSpotlightval: false,
            searchValueval: "all",
            newsCategoryItems: null,
            schoolTypeItems: null,
            schoolItems: null,
            newsItems: null,
            isModified: false,
            onloader: "none",
            paginationMeta: {
                pageNumber: 1,
                pageSize: 10,
                totalPages: 0,
                totalRecords: 0
            },
            editorOption: {
                debug: 'info',
                placeholder: 'Type in here',
                readonlly: true,
                theme: 'snow'
            },
            modals: {
                newModal: false
            }
        };
    },
    methods: {
        openNew() {
            if (this.newsCategoryIdval == 0) {
                this.ShowAlertError('Kindly select News Category', '');
            } else {
                if (this.schoolIdval < 1) {
                    this.ShowAlertError('Kindly select School', '');
                } else {
                    this.isModified = false;
                    this.modals.newModal = true
                }
            }
        },
        resetInput() {
            this.newsIdval = 0;
            this.newsTitleval = "";
            this.newsDetailsShortval = "";
            this.newsDetailsval = "";
            this.newsImagePathval = null;
            this.isSpotlightval = false;
        },
        edititem(item) {
            this.resetInput();
            this.newsIdval = item.newsId;
            this.newsTitleval = item.newsTitle;
            this.newsDetailsval = item.newsDetails;
            this.newsDetailsShortval = item.newsDetailsShort;
            this.newsImagePathval = item.newsImagePath;
            this.isSpotlightval = item.isSpotlight;
            this.isModified = true;
            this.modals.newModal = true;
        },
        submitdata() {
            let newsId = this.newsIdval;
            let newsCategoryId = this.newsCategoryIdval;
            let schoolTypeId = this.schoolTypeIdval;
            let schoolId = this.schoolIdval;
            let newsTitle = this.newsTitleval;
            let newsDetails = this.newsDetailsval;
            let newsDetailsShort = this.newsDetailsShortval;
            let newsImagePath = this.newsImagePathval;
            let isSpotlight = Boolean(this.isSpotlightval);
            let userdata = {};
            this.onloader = "flex";
            let operationVal = "";
            if (this.isModified == false) {
                operationVal = "NewsSetup/CreateNews";
                userdata = {
                    newsCategoryId,
                    schoolTypeId,
                    schoolId,
                    newsTitle,
                    newsDetails,
                    newsDetailsShort,
                    newsImagePath,
                    isSpotlight,
                }
            } else {
                operationVal = "NewsSetup/UpdateNews";
                userdata = {
                    newsId,
                    newsCategoryId,
                    schoolTypeId,
                    schoolId,
                    newsTitle,
                    newsDetails,
                    newsDetailsShort,
                    newsImagePath,
                    isSpotlight,
                }
            }
            this.$store
                .dispatch(operationVal, userdata)
                .then((resp) => {
                    this.onloader = "none";
                    if (resp.responseCode == '00') {
                        this.onSchoolChanged();
                        this.resetInput();
                        this.modals.newModal = false;
                        this.ShowAlertSuccess('Submitted successfully', '');
                    } else {
                        this.ShowAlertError(resp.responseMessage, '');
                    }

                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        UpdateNewsImagePathval(data) {
            this.newsImagePathval = data;
        },
        GetNewsCategoriesForPortal() {
            this.onloader = "flex";

            this.$store
                .dispatch("NewsSetup/GetNewsCategoriesForPortal")
                .then((resp) => {
                    this.newsCategoryItems = resp.data;
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetSchoolTypeForPortal() {
            this.onloader = "flex";
            this.schoolTypeIdval = 0;
            this.$store
                .dispatch("SchoolType/GetSchoolTypeForPortal")
                .then((resp) => {
                    this.schoolTypeItems = resp.data;
                    this.onloader = "none";
                })
                .catch((err) => {
                    console.log(err);
                    this.onloader = "none";
                });
        },
        GetSchoolsForPortal() {
            this.schoolIdval = 0;
            let SchoolTypeId = this.schoolTypeIdval;
            if (SchoolTypeId > 0) {
                this.onloader = "flex";
                this.$store
                    .dispatch("School/GetSchoolsForPortal", SchoolTypeId)
                    .then((resp) => {
                        this.schoolItems = resp.data;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        GetNewsForPortal(meta = this.paginationMeta) {
            this.newsItems = null;

            let SchoolTypeId = this.schoolTypeIdval;

            if (SchoolTypeId > 0) {

                this.paginationMeta = meta;

                this.onloader = "flex";

                const userData = {
                    SearchValue: this.searchValueval,
                    PageNumber: this.paginationMeta.pageNumber,
                    PageSize: this.paginationMeta.pageSize,
                    SchoolTypeId: this.schoolTypeIdval,
                    SchoolId: this.schoolIdval
                };

                this.$store
                    .dispatch("NewsSetup/GetNewsForPortal", userData)
                    .then((resp) => {

                        this.newsItems = resp.data;

                        this.paginationMeta = {

                            pageNumber: resp.pageNumber,

                            pageSize: resp.pageSize,

                            totalPages: resp.totalPages,

                            totalRecords: resp.totalRecords
                        };

                        this.onloader = "none";
                    })
                    .catch((err) => {

                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');

                    });
            }
        },
        onSchoolChanged() {

            // reset to first page
            this.paginationMeta.pageNumber = 1;

            // call API
            this.GetNewsForPortal(this.paginationMeta);

        },
        nextPage() {

            if (this.paginationMeta.pageNumber < this.paginationMeta.totalPages) {

                this.GetNewsForPortal(
                    this.paginationMeta.pageNumber + 1,
                    this.paginationMeta.pageSize
                );
            }
        },

        prevPage() {

            if (this.paginationMeta.pageNumber > 1) {

                this.GetNewsForPortal(
                    this.paginationMeta.pageNumber - 1,
                    this.paginationMeta.pageSize
                );
            }
        },

        frontEndDateFormat(date) {
            return moment(date).format("YYYY-MM-DD");
        },
        backEndDateFormat(date) {
            return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
        },

    },
    mounted() {
        const userDetails = this.accessDetails = this.$store.getters['auth/_user'];
        if (
            userDetails.isSuperAdmin == true ||
            userDetails.isAdmin == true ||
            userDetails.isSupportAdmin == true
        ) {
            this.GetNewsCategoriesForPortal();
            this.GetSchoolTypeForPortal();
        } else {
            this.$store.dispatch("auth/Logout");
            this.$router.push("/login");
        }
    },
};
</script>

<style></style>